/**
 * @file
 * Behaviors common to all the site.
 */
(function($, Drupal) {
    'use strict';

    const {SELECTORS} = Drupal.theme;

    /*
     * Run init function of app
     * when the document is ready
     */
    $(document).ready(function() {
        app.init();
    });

    /*
     * Component app to make all interaction.
     *
     * @namespace app
     */
    const app = {
        /*
         * Control all initialize function of application components
         */
        init() {
            this.initShare.init();
            this.initBooking.init();
            this.initPassword.init();
            this.initCollapse.init();
            this.initSlider.init();
            this.initComplete.init();

            $.datepicker.regional['fr'] = {
                monthNames: ['Janvier', 'Fevrier', 'Mars', 'Avril', 'Mai', 'Juin',
                    'Juillet', 'Aout', 'Septembre', 'Octobre', 'Novembre', 'Decembre'],
                dateFormat: 'dd-mm-yy',
            };
            $.datepicker.setDefaults($.datepicker.regional['fr']);

            $('.form-item-date-min input').datepicker().datepicker('setDate', new Date());
        },

        initShare: {
            selector: {
                content: '.block-social',
                input: '.block-social__input',
            },

            class: {
                opened: 'opened',
            },

            // Variables
            isScrolled: false,

            init() {
                const $input = $(this.selector.input);
                const $content = $(this.selector.content);

                $input.on('click', () => {
                    $content.toggleClass(this.class.opened);
                });
            },
        },

        initBooking: {
            selector: {
                inputOpera: '.booking_options__opera:not(.disabled)',
                inputHome: '.booking_options__home:not(.disabled)',
                submitOpera: '.field--name-field-link-opera a',
                submitHome: '.field--name-field-link-home a',
            },

            class: {
                selected: 'selected',
                disabled: 'disabled',
            },

            init() {
                const $inputOpera = $(this.selector.inputOpera);
                const $inputHome = $(this.selector.inputHome);
                const $submitOpera = $(this.selector.submitOpera);
                const $submitHome = $(this.selector.submitHome);

                $submitHome.addClass(this.class.disabled);

                $inputOpera.on('click', () => {
                    $submitOpera.addClass(this.class.selected);
                    $inputOpera.addClass(this.class.selected);
                    $submitHome.removeClass(this.class.selected);
                    $inputHome.removeClass(this.class.selected);
                    $submitOpera.removeClass(this.class.disabled);
                    $submitHome.removeClass(this.class.disabled);
                });

                $inputHome.on('click', () => {
                    $submitHome.addClass(this.class.selected);
                    $inputHome.addClass(this.class.selected);
                    $submitOpera.removeClass(this.class.selected);
                    $inputOpera.removeClass(this.class.selected);
                    $submitHome.removeClass(this.class.disabled);
                    $submitOpera.removeClass(this.class.disabled);
                });
            },
        },

        initPassword: {
            selector: {
                input: '.password-input',
                eye: '.icon-eye',
            },

            class: {
                activated: 'activated',
            },

            init() {
                const $eye = $(this.selector.input).find(this.selector.eye);

                $eye.on('click', (event) => {
                    const $target = $(event.currentTarget);
                    const $input = $target.next();
                    $target.toggleClass(this.class.activated);
                    if ($target.hasClass(this.class.activated)) {
                        $input.attr('type', 'text');
                    } else {
                        $input.attr('type', 'password');
                    }
                });
            },
        },

        initCollapse: {
            selector: {
                collapsed: '.collapse',
                label: '.field__label',
                item: '.field__item',
            },

            class: {
                closed: 'closed',
            },

            init() {
                const $collapsed = $(this.selector.collapsed);

                $collapsed.find(this.selector.label).on('click', (event) => {
                    $collapsed.find(this.selector.item).toggleClass(this.class.closed);
                    $(event.target).toggleClass(this.class.closed);
                });
            },
        },

        initSlider: {
            selector: {
                left: '.icon.left',
                right: '.icon.right',
                content: '.view-galerie > .view-content',
                item: '.views-field-field-media-gallery .field-content > div',
                video: '.views-field-field-media-video',
                gallery: '.views-field-field-media-gallery',
            },

            init() {
                const $inputLeft = $(this.selector.left);
                const $inputRight = $(this.selector.right);
                const $content = $(this.selector.content);
                const $item = $content.find(this.selector.item);
                const $video = $content.find(this.selector.video);
                const $gallery = $content.find(this.selector.gallery);

                if ($video.width() + $gallery.width() - 20 < window.innerWidth) {
                    $inputLeft.css('display', 'none');
                    $inputRight.css('display', 'none');
                }

                $inputLeft.on('click', () => {
                    const x = $content.position().left;
                    const imgWidth = $item.width();

                    if (x + imgWidth > 0 && x !== 0) {
                        $content.css('left', 0);
                    } else {
                        if (x !== 0) {
                            $content.css('left', x + imgWidth);
                        }
                    }
                });

                $inputRight.on('click', () => {
                    const x = $content.position().left;
                    const imgWidth = $item.width();
                    const contentWidth = -($video.width() + $gallery.width() - 20);

                    if (x - imgWidth >= contentWidth) {
                        $content.css('left', x - imgWidth);
                    }
                });
            },
        },

        initComplete: {
            selector: {
                btn: '.block-header-booking-event',
                complete: '.complete-event',
            },

            init() {
                const $btn = $(this.selector.btn);
                const $complete = $(this.selector.complete);

                if ($complete.length > 0) {
                    $btn.addClass('complete');
                }
            },
        },
    };

    Drupal.behaviors.initNav = {
        selector: {
            header: '.header',
            headerMenu: '.header__menu',
            headerMenuPrimaryEvent: '.nav-cta',
            headerMenuPrimaryContent: '#block-opera-limoges-main-menu',
            headerMenuSearchEvent: '.icon-SearchIcon',
            headerMenuSearchContent: '.region-highlighted',
            html: 'html',
        },

        class: {
            classSticky: 'sticky',
            opened: 'opened',
            used: 'used',
            remove: 'remove',
            headerMenuSearchContentClose: 'views-exposed-form',
        },

        // Variables
        isScrolled: false,

        attach(context) {
            if (context === document) {
                this.init();
            }
        },

        init() {
            // Add sticky class.
            const $header = $(this.selector.header);
            this.scrollEvent($header);

            SELECTORS.$window.on('scroll', () => {
                this.scrollEvent($header);
            });

            const $headerMenu = $(this.selector.headerMenu);
            const $primaryContent = $headerMenu.find(this.selector.headerMenuPrimaryContent);
            const $searchContent = $(this.selector.headerMenuSearchContent);
            const $html = $(this.selector.html);

            if (!$searchContent.length) {
                $(this.selector.headerMenuSearchEvent).addClass(this.class.remove);
            }

            $headerMenu.find(this.selector.headerMenuPrimaryEvent).on('click', () => {
                if (!$primaryContent.hasClass(this.class.opened)) {
                    $primaryContent.removeClass(this.class.opened);
                    $primaryContent.addClass(this.class.opened);
                } else {
                    $primaryContent.removeClass(this.class.opened);
                }
            });

            $headerMenu.find(this.selector.headerMenuSearchEvent).on('click', () => {
                $searchContent.toggleClass(this.class.used);
                $html.toggleClass(this.class.used);
            });

            $searchContent.on('click', (event) => {
                if ($(event.target).hasClass(this.class.headerMenuSearchContentClose)) {
                    $searchContent.removeClass(this.class.used);
                    $html.removeClass(this.class.used);
                }
            });
        },

        /**
         * Sticky class added on scroll.
         * @param {string} $header
         */
        scrollEvent($header) {
            const hasScrolled = window.scrollY > 10;
            if (this.isScrolled !== hasScrolled) {
                this.isScrolled = hasScrolled;
                $header.toggleClass(this.class.classSticky, hasScrolled);
            }
        },
    };

    Drupal.behaviors.initDelay = {
        container: 'block-views-exposed-filter-blocksearch-page',
        selector: {
            focusedItems: '.form-item-text, .form-item-date-min, .form-item-date-max, .form-composite',
            mobileContainer: 'form',
            durationContainer: '.js-fieldset-duration',
            priceContainer: '.js-fieldset-price',
            selectedHour: '.selected-hours',
            selectedPrice: '.selected-price',
            durationDropdown: '.selected-hours + .fieldset-wrapper',
            priceDropdown: '.selected-price + .fieldset-wrapper',
            durationItems: '.selected-hours + .fieldset-wrapper .form-radios .form-item',
            priceItems: '.selected-price + .fieldset-wrapper .form-item',
        },

        class: {
            selected: 'selected',
            opened: 'opened',
            focused: 'focused',
        },

        // Variables
        isScrolled: false,

        attach(context) {
            if (context === document) {
                const $containers = $(context).find('.' + this.container);
                $containers.each((_index, element) => {
                    this.init($(element));
                });
            } else if ($(context).hasClass(this.container)) {
                this.init($(context));
            }
        },

        init($container) {
            this.setFocusEvent($container);
            this.setMobileBehavior($container);
            this.setDurationBehavior($container);
            this.setPriceBehavior($container);
        },

        /**
         * Attach focus event
         * @param {elem} $container
         */
        setFocusEvent($container) {
            const $focusedItems = $container.find(this.selector.focusedItems);
            $focusedItems.on('click', (event) => {
                $focusedItems.removeClass(this.class.focused);
                $(event.currentTarget).addClass(this.class.focused);
            });
        },

        /**
         * Open & close for mobile
         * @param {elem} $container
         */
        setMobileBehavior($container) {
            $container.find(this.selector.mobileContainer).on('click', (event) => {
                $(event.currentTarget).addClass(this.class.opened);
            });
        },

        /**
         * Set duration field behavior
         * @param {elem} $container
         */
        setDurationBehavior($container) {
            const $durationContainer = $container.find(this.selector.durationContainer);
            const $selectedHour = $durationContainer.find(this.selector.selectedHour);
            const $dropdown = $durationContainer.find(this.selector.durationDropdown);
            const $durationItems = $durationContainer.find(this.selector.durationItems);

            // Set default duration
            $durationItems.each((_index, element) => {
                const $currentDuration = $(element);
                if ($currentDuration.find('input').is(':checked')) {
                    $currentDuration.toggleClass('selected');
                    $selectedHour.text($currentDuration.find('label').text());
                    return false;
                }
            });

            // Dropdown toggle
            $durationContainer.on('click', (event) => {
                if (!$(event.target).closest('.' + this.container + ' ' + this.selector.durationDropdown).length) {
                    $dropdown.toggleClass(this.class.opened);
                    $durationContainer.toggleClass(this.class.opened);
                }
            });

            $(window).on('click', (event) => {
                if (!$(event.target).closest('.' + this.container + ' ' + this.selector.durationContainer).length) {
                    $dropdown.removeClass(this.class.opened);
                    $durationContainer.removeClass(this.class.opened);
                }
            });

            // Change duration
            $durationItems.on('click', (event) => {
                const $selectedDuration = $(event.currentTarget);
                $durationItems.removeClass(this.class.selected);
                $selectedDuration.toggleClass(this.class.selected);
                $selectedDuration.find('input').prop('checked', true);
                $selectedHour.text($selectedDuration.find('label').text());
            });
        },

        /**
         * Set price field behavior
         * @param {elem} $container
         */
        setPriceBehavior($container) {
            const $priceContainer = $container.find(this.selector.priceContainer);
            const $selectedHour = $priceContainer.find(this.selector.selectedPrice);
            const $dropdown = $priceContainer.find(this.selector.priceDropdown);
            const $priceItems = $priceContainer.find(this.selector.priceItems);

            // Set default price
            $priceItems.each((_index, element) => {
                const $currentPrice = $(element);
                if ($currentPrice.find('input').is(':checked')) {
                    $currentPrice.toggleClass('selected');
                    $selectedHour.text($currentPrice.find('label').text());
                    return false;
                }
            });

            // Dropdown toggle
            $priceContainer.on('click', (event) => {
                console.log($dropdown);
                if (!$(event.target).closest('.' + this.container + ' ' + this.selector.priceDropdown).length) {
                    $dropdown.toggleClass(this.class.opened);
                    $priceContainer.toggleClass(this.class.opened);
                }
            });

            $(window).on('click', (event) => {
                if (!$(event.target).closest('.' + this.container + ' ' + this.selector.priceContainer).length) {
                    $dropdown.removeClass(this.class.opened);
                    $priceContainer.removeClass(this.class.opened);
                }
            });

            // Change price
            $priceItems.on('click', (event) => {
                const $selectedPrice = $(event.currentTarget);
                $priceItems.removeClass(this.class.selected);
                $selectedPrice.toggleClass(this.class.selected);
                $selectedPrice.find('input').prop('checked', true);
                $selectedHour.text($selectedPrice.find('label').text());
            });
        },
    };
})(jQuery, Drupal);
